"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyle = exports.FontContainer = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.FontContainer = theme_1.styled.div `
  ${({ theme }) => {
    if (theme.common['font-url']) {
        return `
      * {
        font-family: ${theme.common['font-url']}
      }`;
    }
    else if (theme.common['font-family']) {
        return `
      * {
        font-family: ${theme.common['font-family']}
      }`;
    }
    return '';
}};
`;
exports.GlobalStyle = (0, theme_1.createGlobalStyle) `
  .theme-container {
    ${({ theme }) => {
    if (theme.common['font-url'])
        return `
          * {
            font-family: ${theme.common['font-url']}
          }`;
    else if (theme.common['font-family']) {
        return `
          * {
            font-family: ${theme.common['font-family']}
          }`;
    }
    return '';
}};
  };

  .theme-container :focus-visible {
    outline: none;
  }

  .theme-container :focus {
    outline: none !important;
  }

  iframe {
    border: none;
  }

  .theme-container  {
    margin: 0;
    background-color: white;
    font-family: 'Roboto Flex', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .theme-container code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }

  .theme-container h1,
  .theme-container h2,
  .theme-container h3,
  .theme-container h4 {
    margin-top: 0;
  }

  .theme-container h2 {
    margin-bottom: 8px;
  }

  .theme-container ul {
    margin: 0;
    padding-left: 0;
  }

  .theme-container li {
    list-style-type: disc;
  }

  .theme-container {
    background: #f1f2f6;
  }

  .theme-container [data-reach-menu-popover] {
    z-index: 1000;
  }
`;
